import * as React from 'react';
import { clsx as cx } from 'clsx';

import { TFooterType } from '../../types/footerType';

import * as styles from './MobileFooterLayout.css';

interface IMobileFooterLayoutProps extends React.PropsWithChildren {
  type: TFooterType;
}

export const MobileFooterLayout: React.FC<IMobileFooterLayoutProps> = ({ type, children }) => {
  return (
    <div className={cx(styles['footer-mobile'], type === 'adaptive' && styles['footer-mobile--adaptive'])}>
      {children}
    </div>
  );
};
